import { Routes } from '@angular/router';
import { HomePageComponent } from 'src/app/pages/home-page/home-page.component';
import { MenuPageComponent } from 'src/app/pages/menu-page/menu-page.component';
import { MenusPageComponent } from 'src/app/pages/menus-page/menus-page.component';
import { TicketsPageComponent } from 'src/app/pages/tickets-bar-page/tickets-page.component';

import {
  AngularFireAuthGuard,
  redirectLoggedInTo,
  redirectUnauthorizedTo,
} from '@angular/fire/compat/auth-guard';
import { EventsPageComponent } from 'src/app/pages/events-page/events-page.component';
import { TicketPageComponent } from 'src/app/pages/ticket-bar-page/ticket-page.component';
import { ProfilePageComponent } from 'src/app/pages/profile-page/profile-page.component';
import { TicketsAccessPageComponent } from 'src/app/pages/tickets-access-page/tickets-access-page.component';
import { EventPageComponent } from 'src/app/pages/event-page/event-page.component';
import { TicketAccessPageComponent } from 'src/app/pages/ticket-access-page/ticket-access-page.component';
import { PricingPageComponent } from 'src/app/pages/pricing-page/pricing-page.component';
import { BusinessPageComponent } from 'src/app/pages/business-page/business-page.component';
import { ServicesPageComponent } from 'src/app/pages/services-page/services-page.component';
import { CreateEventsPageComponent } from 'src/app/pages/create-events-page/create-events-page.component';

const redirectUnauthorizedToLogin = () => redirectUnauthorizedTo(['']);

export const HomeLayoutRoutes: Routes = [
  {
    path: '',
    redirectTo: 'welcome',
    pathMatch: 'full',
  },
  {
    path: 'welcome',
    component: HomePageComponent,
  },
  {
    path: 'menus',
    component: MenusPageComponent,
  },
  {
    path: 'menus/:id',
    component: MenuPageComponent,
  },

  {
    path: 'tickets-bar',
    component: TicketsPageComponent,
    data: { authGuardPipe: redirectUnauthorizedToLogin },
    canActivate: [AngularFireAuthGuard],
  },
  {
    path: 'tickets-bar/:id',
    component: TicketPageComponent,
    data: { authGuardPipe: redirectUnauthorizedToLogin },
    canActivate: [AngularFireAuthGuard],
  },

  {
    path: 'tickets-access',
    component: TicketsAccessPageComponent,
    data: { authGuardPipe: redirectUnauthorizedToLogin },
    canActivate: [AngularFireAuthGuard],
  },
  {
    path: 'tickets-access/:id',
    component: TicketAccessPageComponent,
    data: { authGuardPipe: redirectUnauthorizedToLogin },

    canActivate: [AngularFireAuthGuard],
  },
  {
    path: 'profile',
    component: ProfilePageComponent,
    data: { authGuardPipe: redirectUnauthorizedToLogin },
    canActivate: [AngularFireAuthGuard],
  },
  {
    path: 'events',
    component: EventsPageComponent,
  },
  {
    path: 'events/:id',
    component: EventPageComponent,
  },
  {
    path: 'pricing',
    component: PricingPageComponent,
  },
  {
    path: 'business',
    component: BusinessPageComponent,
  },
  {
    path: 'services',
    component: ServicesPageComponent,
  },
  {
    path: 'create-events',
    component: CreateEventsPageComponent,
  },
];
